module.exports = __webpack_public_path__ + "img/감사배경.effdd189.jpeg";